import _ from "lodash";
import React from "react";

import CardSecondary from "@/components/UI/Card/CardSecondary";

export function GenericMultiselect(props) {
  const {
    editable,
    editHandler,
    isCheckboxes,
    labelClass,
    noneSelectedMessage,
    note,
    profileView,
    sectionKey,
    sectionLabel,
  } = props;

  let sectionMultiselect = note.content[sectionKey];

  const handleEditCopyChange = (e, index, key) => {
    if (!editable) {
      return;
    }

    let editCopyClone = _.cloneDeep(note.content[sectionKey]);

    editCopyClone[index][key] = !editCopyClone[index][key];

    if (index === "none") {
      Object.entries(editCopyClone).forEach(([sectionKey, value]) => {
        if (sectionKey !== "none") {
          value[key] = false;
        }
      });
    } else if (editCopyClone["none"] != null) {
      editCopyClone["none"][key] = false;
    }

    if (editHandler) {
      editHandler(sectionKey, editCopyClone);
    }
  };

  const isNoneSelected =
    noneSelectedMessage != null &&
    Object.values(sectionMultiselect).every((section) => !section.answer);

  let innerContent = (
    <>
      <div>
        <div className={`float-left tw:font-bold ${labelClass}`}>{sectionLabel}</div>
      </div>
      <br />
      {isNoneSelected && <div className="fs-12">{noneSelectedMessage}</div>}

      <div className="row print-wrap">
        {Object.entries(sectionMultiselect)
          .sort((a, b) => (a[1].order && b[1].order ? a[1].order - b[1].order : 0))
          .map(([key, value]) => {
            let style = {
              borderRadius: 3,
              cursor: editable ? "pointer" : "default",
            };

            if (value.answer) {
              style.border = 0;
            }

            if (isCheckboxes) {
              return (
                <div
                  className="col-6 pr-0 my-1 py-1 fs-12"
                  key={key}
                  onClick={(e) => {
                    handleEditCopyChange(e, key, "answer");
                  }}
                >
                  <input checked={sectionMultiselect[key].answer ? true : null} type="checkbox" />
                  <span className="ml-2">{value.label}</span>
                </div>
              );
            } else {
              return (
                <div
                  className="col-lg-4 col-md-4 col-6 my-1 py-1 fs-12 tw:justify-center"
                  key={key}
                >
                  <button
                    className={
                      "w-100 text-break text-center cursor-none tw:font-normal " +
                      (value.answer ? "Btn--sec activeOptionBtn" : "Btn--otl-gry inactiveOptionBtn")
                    }
                    onClick={(e) => {
                      handleEditCopyChange(e, key, "answer");
                    }}
                    style={style}
                    value={key}
                  >
                    {value.label}
                  </button>
                </div>
              );
            }
          })}
      </div>
    </>
  );

  let content;

  if (!profileView) {
    content = (
      <CardSecondary
        className={"mx-0 px-3 py-3 my-3 max-width " + props.className}
        style={{ minHeight: 150 }}
      >
        {innerContent}
      </CardSecondary>
    );
  } else {
    content = (
      <div className={props.className} style={{ minHeight: 150 }}>
        {innerContent}
      </div>
    );
  }

  return <>{content}</>;
}
